var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"canvas-style",attrs:{"id":_vm.canvasId},on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"mousemove":_vm.onMouseMove}})])}
var staticRenderFns = []

export { render, staticRenderFns }